export enum ExceptionCategory {
    CLIENT_CONFIGURATION = 'CLIENT_CONFIGURATION',
    REPORTS = 'REPORTS',
    STATISTICS = 'STATISTICS',
    MONITORING = 'MONITORING',
    CUSTOMER_ACCOUNT_FAILURE = 'CUSTOMER_ACCOUNT_FAILURE',
    ENROLLMENT = 'ENROLLMENT',
    INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
    LOGIN_FAILURE = 'LOGIN_FAILURE',
    UNAUTHORIZED_ACCESS = 'UNAUTHORIZED_ACCESS'
}

